import avatarComponent from './avatar.component';
import AvatarCache from './avatarCache.service';

let avatarModule = angular.module('components.avatar', [])
  .config(function ($sceDelegateProvider) {
    'ngInject';

    $sceDelegateProvider.resourceUrlWhitelist([
      // Allow same origin resource loads.
      'self',
      // Allow loading from our assets domain.  Notice the difference between * and **.
      '*'
    ]);
  })

  .component('avatarApp', avatarComponent)
  .service('avatarCache', AvatarCache)
  .name;

export default avatarModule;



// WEBPACK FOOTER //
// ./client/app/components/avatar/avatar.js